/* Copyright (c) 2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { of, OperatorFunction, timer } from 'rxjs';
import { mapTo, switchMap } from 'rxjs/operators';

/**
 * Function is used for gamepad buttons which keydown event is sent repeatedly
 * when button is pressed then stop at releasing button, keyup event is sent.
 * Like physical keyboard does to do event handling.
 */
export function repeatedPress(duration: number): OperatorFunction<boolean, boolean> {
    return switchMap(pressed => {
        if (!pressed) {
            return of(false);
        }
        return timer(0, duration).pipe(mapTo(true));
    });
}
